import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { useCallback, useMemo, useState } from 'react';
import OverlappingIcons from './OverlappingIcons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_VISIBLE_ICONS = 3;
export const OverlappingIconsButton = ({
  icons = [],
  onClick,
  children,
  selected = false,
  // Background Color Props
  backgroundColor = 'fill-surface-default',
  hoverBackgroundColor = 'fill-secondary-hover',
  selectedBackgroundColor = 'fill-surface-recessed',
  // Border Style Props
  borderWidth,
  borderStyle,
  borderColor,
  selectedBorderColor = borderColor
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleClick = useCallback(event => {
    onClick === null || onClick === void 0 || onClick(event);
  }, [onClick]);
  const visibleIcons = icons.slice(0, MAX_VISIBLE_ICONS);
  const backgroundColorToUse = useMemo(() => {
    if (isHovered) {
      return hoverBackgroundColor;
    }
    if (selected) {
      return selectedBackgroundColor;
    }
    return backgroundColor;
  }, [isHovered, selected, backgroundColor, hoverBackgroundColor, selectedBackgroundColor]);
  return /*#__PURE__*/_jsx(Button, {
    use: "unstyled",
    onClick: handleClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    padding: "0",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: backgroundColorToUse,
      blockSize: "30px",
      gap: "100",
      paddingBlockStart: "50",
      paddingInlineStart: "100",
      paddingInlineEnd: "200",
      borderWidth: borderWidth,
      borderStyle: borderStyle,
      borderColor: selected || isHovered ? selectedBorderColor : borderColor,
      borderRadius: "200",
      children: [/*#__PURE__*/_jsx(OverlappingIcons, {
        icons: visibleIcons
      }), children]
    })
  });
};
OverlappingIconsButton.displayName = 'OverlappingIconsButton';